<template>
    <confirm-dialog
        ref="dialog"
        :question-text="
            $t(`dialogs.childPromotionGhost.header${isGhost ? 'Reinstatiate' : 'Decline'}`)
        "
        :action-text="$t('actions.ok')"
        :has-activator="true"
        @confirm="confirm"
    >
        <template v-slot:actions="{ activator }">
            <v-btn
                v-bind="activator"
                :disabled="isGhostDisabled"
                :icon="isGhost ? 'custom:reinstatiate' : 'custom:remove'"
                size="x-small"
                elevation="0"
                :ripple="false"
                @click.stop="openDialog"
            />
        </template>
    </confirm-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    props: {
        promotionId: {
            type: String,
            required: true,
        },
        isGhost: {
            type: Boolean,
            default: false,
        },
        isGhostDisabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['confirm'],
    computed: {
        ...mapState('clientConfig', ['toggleLogic']),
    },

    methods: {
        ...mapActions('promotions', ['setChildPromotionIsGhost']),
        ...mapActions('execution', ['deleteSinglePromotion']),

        async confirm() {
            await this.setChildPromotionIsGhost({
                promotionId: this.promotionId,
                isGhost: !this.isGhost,
            });
            this.$emit('confirm');
        },

        openDialog() {
            this.$refs.dialog.open();
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';
</style>
